import {
  CHOSEN_PARTNER_FULL_NAME,
  CHOSEN_PARTNER_ID,
  CHOSEN_PARTNER_NAME,
} from '../../configs/app.config';

import type { IPartnerChosenIdNames } from './partner.handler.type';

export const handleSetPartnerId = ({
  chosenPartnerId,
  chosenPartnerFullName,
}: IPartnerChosenIdNames): void => {
  sessionStorage.setItem(CHOSEN_PARTNER_ID, chosenPartnerId);
  sessionStorage.setItem(CHOSEN_PARTNER_FULL_NAME, chosenPartnerFullName);
  sessionStorage.setItem(
    CHOSEN_PARTNER_NAME,
    chosenPartnerId.split('-').pop()?.toUpperCase() || '',
  );
};
